import { render, staticRenderFns } from "./FreeAnswer.vue?vue&type=template&id=4af1042f&"
import script from "./FreeAnswer.vue?vue&type=script&lang=js&"
export * from "./FreeAnswer.vue?vue&type=script&lang=js&"
import style0 from "./FreeAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports